import users from 'modules/core/store/collections/users'

import { periodEmployee } from 'modules/attendance/lib/periodEmployee'
import type Period from 'modules/attendance/store/models/Period'
import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'

export const filterByEmployee = (
  filteredEmployees: Employee[],
  customPeriods: Period[],
  filterBy: string
): Period[] => {
  const employeesId = new Set(filteredEmployees.map((e) => e.attributes.id))

  return customPeriods.filter((p) => {
    const employeeForPeriod = periodEmployee(p, employees)

    if (!employeesId.has(employeeForPeriod.attributes.id)) {
      return false
    }

    const user = users.get(employeeForPeriod.attributes.access_id)
    if (!user) {
      throw Error(`Error getting users with id = ${employeeForPeriod.attributes.access_id}`)
    }
    return user.matchesName(filterBy)
  })
}
